import { useSyncExternalStore } from "react";

const MEDIA_QUERY = "(prefers-reduced-motion: reduce)";

function getQuery(): MediaQueryList | null {
  if (typeof window === "undefined") return null;

  if (typeof window.matchMedia !== "function") return null;

  return window.matchMedia(MEDIA_QUERY);
}

function subscribe(callback: () => void) {
  const query = getQuery();
  query?.addEventListener("change", callback);
  return () => query?.removeEventListener("change", callback);
}
function getSnapshot() {
  return getQuery()?.matches ?? false;
}
function getServerSnapshot() {
  return false;
}
export function useReducedMotion() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
